import React, { ComponentType, FunctionComponent, memo } from "react";

import { Card } from "@/components/Card";

interface IStyledModalProps {
  className?: string;
}

export const StyledModal: FunctionComponent<IStyledModalProps> = props => (
  <Card className={props.className} flex grow={1} width={12} padding={[false]} border={[false]}>
    {props.children}
  </Card>
);

export function inStyledModal<P>(Component: ComponentType<P>) {
  type Props = P;

  const InStyledModal: FunctionComponent<Props> = memo(props => {
    return (
      <StyledModal>
        <Component {...props} />
      </StyledModal>
    );
  });

  return InStyledModal;
}
